import HeaderCustomMenuItem from './HeaderCustomMenuItem'
import CustomMenuLink from './CustomMenuLink'
import CustomMenuDropdown from './CustomMenuDropdown'
import CustomMenuDrawer from './CustomMenuDrawer'
import CustomMenuModal from './CustomMenuModal'

// Rename HeaderCustomMenuItem for export to maintain compatibility
const HeaderCustomMenu = HeaderCustomMenuItem

export {
    HeaderCustomMenu,
    CustomMenuLink,
    CustomMenuDropdown,
    CustomMenuDrawer,
    CustomMenuModal,
}

export default HeaderCustomMenu
